import React, { useEffect, useState } from "react";
import "./VerifyEmail.css";
import "./Login.css";
import LoginLogo from "../../Components/Assets/images/logo2.png";
import { Link, useSearchParams } from "react-router-dom";
import { useTitle } from "../../hooks/useTitle";
import { account } from "../../appwrite";
import { CheckCircle, XCircle, Loader } from "lucide-react";

function EmailVerified() {
  useTitle("Email Verified - TrendBay");
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error

  useEffect(() => {
    const userId = searchParams.get("userId");
    const secret = searchParams.get("secret");

    if (!userId || !secret) {
      setStatus("error");
      return;
    }

    account
      .updateVerification(userId, secret)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, []);

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: "center" }}>
        <a href="/">
          <img className="auth-logo" src={LoginLogo} alt="TrendBay" />
        </a>

        {status === "loading" && (
          <>
            <div className="verify-email-icon">
              <Loader
                size={32}
                color="#00A855"
                strokeWidth={1.5}
                className="spin"
              />
            </div>
            <h1 className="auth-heading">Verifying…</h1>
            <p className="auth-sub">Hang on while we verify your email.</p>
          </>
        )}

        {status === "success" && (
          <>
            <div
              className="verify-email-icon"
              style={{ background: "#f0fdf6" }}
            >
              <CheckCircle size={36} color="#00A855" strokeWidth={1.5} />
            </div>
            <h1 className="auth-heading">Email verified!</h1>
            <p className="auth-sub">
              Your account is ready. Sign in to start shopping.
            </p>
            <Link
              to="/login"
              className="auth-btn-primary"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
                marginTop: 8,
              }}
            >
              Go to Sign In
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <div
              className="verify-email-icon"
              style={{ background: "#fff5f5" }}
            >
              <XCircle size={36} color="#c0392b" strokeWidth={1.5} />
            </div>
            <h1 className="auth-heading">Verification failed</h1>
            <p className="auth-sub">
              This link may have expired or already been used.
            </p>
            <Link
              to="/login"
              className="auth-btn-primary"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
                marginTop: 8,
              }}
            >
              Go to Sign In
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export default EmailVerified;
